import AvailabilityDot from '@/components/integration/nylas/scheduler/components/availability/AvailabilityDot'
import SkeletonText from '@/components/skeleton/SkeletonText'

interface Props {
  count: number
  size?: 'sm' | 'md'
  isLoading: boolean
}

const AvailableSlotsIndicator: React.FC<Props> = ({
  count,
  size,
  isLoading,
}) => {
  const showText = size === 'md'

  return (
    <span className="text-body text-xxs flex items-center gap-1">
      {isLoading ? (
        <SkeletonText length={showText ? 6 : 4} style={{ height: '1em' }} />
      ) : (
        <>
          <AvailabilityDot count={count} size={size} />

          {count > 0 && (
            <>
              <span className={showText ? '' : 'sr-only'}>
                {count} {count === 1 ? 'slot' : 'slots'}
              </span>
            </>
          )}
        </>
      )}
    </span>
  )
}

export default AvailableSlotsIndicator
